export default __webpack_public_path__ + "static/media/react.1190ff99.svg";